import React, { useEffect, useState } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
} from "@ionic/react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  Typography,
  Button,
} from "@mui/material";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import { useBusinessContext } from "../../context/business-context";
import { baseUrl, config, requestID } from "../../common/utils";
import { Business } from "@mui/icons-material";

const AuditTrail: React.FC = () => {

    const { selectedBusiness} = useBusinessContext()
  
  const { selectedBusinessId,selectedBusinessName } = useBusinessContext();
  const { id } = useParams();
  const history = useHistory();
  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const getAuditLog = async () => {
    setLoading(true);
    setError(false);

    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);
      const response = await axios.post(
        baseUrl() + "audittrails/getAuditTrails_caas",
        formData,
        config
      );

      console.log({ response });

      if (response.data?.data) {
        setAuditData(response.data.data);
      } else {
        setError(true);
      }
    } catch (err) {
      console.error("Error fetching audit logs:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAuditLog();
  }, []);

  return (
    <IonPage>
      <IonHeader>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Typography variant="h6" sx={{ color: "chocolate", flex: 1 }}>
            {/* <Business className={styles.titleIcon} /> */}
            {selectedBusinessName.toUpperCase()} - Audit Trail
          </Typography>

          <Button
            variant="outlined"
            color="secondary"
            onClick={() => history.goBack()}
            style={{ marginLeft: 10 }}
          >
            Go Back
          </Button>
        </Box>
      </IonHeader>

      <IonContent className="ion-padding">
        {loading ? (
          <CircularProgress style={{ display: "block", margin: "20px auto" }} />
        ) : error ? (
          <p style={{ textAlign: "center", color: "red" }}>
            Failed to load audit logs.
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>activity</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>audit_trail_id</TableCell>
                  <TableCell>branchID</TableCell>
                  <TableCell>branch_id</TableCell>
                  <TableCell>Details</TableCell>
                  <TableCell>business_id</TableCell>

                  <TableCell>dateCreated</TableCell>
                  <TableCell>dateModified</TableCell>
                  <TableCell>id</TableCell>
                  <TableCell>modifiedBy</TableCell>
                  <TableCell>staffID</TableCell>
                  <TableCell>status</TableCell>
                  <TableCell>user_id</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {auditData.length > 0 ? (
                  auditData.map((row: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>{row.activity}</TableCell>
                      <TableCell>{row.amount}</TableCell>
                      <TableCell>{row.audit_trail_id}</TableCell>
                      <TableCell>{row.branchID}</TableCell>
                      <TableCell>{row.branch_id}</TableCell>

                      <TableCell>{row.business_id}</TableCell>
                      <TableCell>{row.dateCreated}</TableCell>
                      <TableCell>{row.dateModified}</TableCell>
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.modifiedBy}</TableCell>
                      <TableCell>{row.staffID}</TableCell>
                      <TableCell>{row.status}</TableCell>
                      <TableCell>{row.user_id}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} style={{ textAlign: "center" }}>
                      No audit logs found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </IonContent>
    </IonPage>
  );
};

export default AuditTrail;
